import commonConfig from "@/v2-common/config"

const config = {
  ...commonConfig,
  sentryDsn:
    "https://d2d5c34e0f51be4c7a8ef31a4345a62e@o40672.ingest.us.sentry.io/4511294386143232",
  consoleV1Url: "https://console.placepoint.no",
  consoleV2Url: "https://app.placepoint.no",
  propcloudUrl: "https://app.propcloud.no",
  newsecmapsUrl: "https://app.newsecmaps.no",
  marketingUrl: "https://placepoint.no",
  docsUrl: "https://docs.placepoint.no",
}

if (window.env) {
  if (window.env.ENV_NAME) config.envName = window.env.ENV_NAME
  if (window.env.ENV_TYPE) config.envType = window.env.ENV_TYPE
  if (window.env.VERSION) config.version = window.env.VERSION
  if (window.env.LOG_LEVEL) config.logLevel = window.env.LOG_LEVEL
  if (window.env.SLOT) config.slot = window.env.SLOT
  if (window.env.REGION) {
    config.region = window.env.REGION
    config.isRemote = config.region !== "local"
    config.isLocal = config.region === "local"
    config.isFailover = config.region === "westeu"
  }

  const ec = window.env.ENV_CONFIG
  if (ec) {
    if (ec.PLACEPOINT_MARKETING_URL)
      config.marketingUrl = ec.PLACEPOINT_MARKETING_URL
    if (ec.PLACEPOINT_CONSOLE_URL)
      config.consoleV1Url = ec.PLACEPOINT_CONSOLE_URL
    if (ec.PLACEPOINT_DOCS_URL) config.docsUrl = ec.PLACEPOINT_DOCS_URL
  }
}

export default config
